var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('button',{staticClass:"masthead__scroll-button absolute uppercase",on:{"click":_vm.scrollButtonCLickHandler}},[_vm._v("\n        "+_vm._s(_vm.scrollButtonWording)+"\n    ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }